import React from 'react';
import NumberFormat from 'react-number-format';
import * as PropTypes from 'prop-types';

function NumberFormatDecimal5(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.floatValue,
                    },
                });
            }}
            thousandSeparator=" "
            allowNegative={false}
            decimalScale={5}
            decimalSeparator=","
            isNumericString
        />
    );
}

NumberFormatDecimal5.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default NumberFormatDecimal5;